export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'header',
        type: 'string',
        useInFilter: true,
    },
    {
        name: 'txt',
        type: 'string',
        useInFilter: true,
    },
    {
        name: 'pos',
        sortField: 'pos',
        type: 'number',
        useInFilter: true,
    },
    {
        name: 'sr',
        sortField: 'sr',
        type: 'sr',
        callback: 'sr',
        useInFilter: true,
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
        engine: "yandex"
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'mincpc',
        sortField: 'cpc_min',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'maxcpc',
        sortField: 'cpc_max',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    }
]
